import React from 'react';
import { Outlet } from 'react-router-dom';

function Definitions() {
  return <Outlet />;
}

export default Definitions;
